import React, { useState, useEffect } from 'react';
import { Row, Col, CardBody, Input, Button, FormGroup, Label, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import APIClient from '../../../helpers/APIClient';
import Loader from '../../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../../constants/environment';
import { checkRole } from '../../../helpers/Roles';
import moment from 'moment';
import styled from 'styled-components';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import IconCheckboxActive from "../../../assets/images/icon-checkbox-active.png";
import IconCheckboxPart from "../../../assets/images/icon-checkbox-part.png";
import IconCheckbox from "../../../assets/images/icon-checkbox.png";

export const ActionType = [
    {
        label: "Gặp trực tiếp",
        value: 'meet'
    },
    {
        label: "Gọi điện",
        value: 'call'
    },
    {
        label: "Nhắn tin",
        value: 'message'
    },
    {
        label: "Gửi Email",
        value: 'email'
    },
    {
        label: "Chat page",
        value: 'chat_page'
    },
    {
        label: "Chat tiktok",
        value: 'chat_tiktok'
    },
]

export const ActionStatus = [
    {
        label: "Mới",
        value: 0
    },
    {
        label: "Thành công",
        value: 1
    },
    {
        label: "Thất bại",
        value: -1
    }
]

const ActionAdd = (props: any) => {
    const [users, setUser] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checkNext, setCheckNext] = useState<any>(false)
    const [data, setData] = useState<any>({
        day: moment().valueOf(),
        branch_id: props?.user?.branch_id?.id,
    });
    const { closeModal, action, onlyView, examination_id } = props
    const type = action?.type

    useEffect(() => {
        loadInit()
    }, []);

    useEffect(() => {
        if (action?.data?.id) {
            loadData(action?.data?.id)
        }
    }, [action?.data]);

    useEffect(() => {
        if (type === "editAction" || action.type === "editAction") {
            setCheckNext(true)
        }
    }, [type, data]);
    //kiểm tra xem action_user_uid : người thực hiện nếu chưa có sẽ set default người thao tác
    useEffect(() => {
        if (!data?.action_user_uid) {
            setData({ ...data, action_user_uid: props?.user?.id });
        } else {
            const selectedUser: any = users.find((user: any) => user.value === data?.action_user_uid);
            if (selectedUser) {
                setData({ ...data, action_user_uid: selectedUser.value });
            }
        }
      
    }, [data?.action_user_uid,  props?.user?.id, users]);

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        }
        const [
            responseUser,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/user`, {
                ...params,
            }),
        ]);
        if (responseUser.response?.data !== undefined) {
            let ListArr: any = [];
            responseUser.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setUser(ListArr)
        }
    }

    const loadData = async (id: number) => {
        const url = `${baseUrl}/examination-action/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData({
                ...resData,
                action_user_uid: resData?.action_user_uid?.id,
                examination_id: resData?.examination_id?.id,
            })
        }
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if (name === "payment_total" && data?.max_payment_total) {
            value = data?.max_payment_total
            toast.warning('Vượt quá số tiền cần phải thanh toán')
        }
        setData({
            ...data,
            [name]: value
        })
    }

    const validationFrom = () => {
        if (!(data?.type)) {
            toast.warning('Loại hoạt động không được để trống!');
            return false
        }
        if (!(data?.action_user_uid)) {
            toast.warning('Người thực hiện không được để trống!');
            return false
        }
        if (!(data?.day)) {
            toast.warning('Thời gian thực hiện không được để trống!');
            return false
        }
        if(data?.next_day || data?.next_type ) {
            if (!(data?.next_type)) {
                toast.warning('Người thực hiện không được để trống!');
                return false
            }
            if (!(data?.next_day)) {
                toast.warning('Thời gian thực hiện không được để trống!');
                return false
            }
        }
        return true
    }

    const handleSubmit = async (status?: number) => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/examination-action`;
        const params = {
            "examination_id": examination_id,
            "type": data?.type,
            "action_user_uid": data?.action_user_uid,
            "day": moment(data?.day).valueOf(),
            "content": data?.content,
            "status": status ? status : 0,
            "next_type": data?.next_type,
            "next_day":  data?.next_day ? moment(data.next_day).valueOf() : undefined,
            "next_action_user_uid": data?.next_action_user_uid,
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo hoạt động thành công')
            closeModal()
            props.loadData()
        }
    }

    const handleEdit = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/examination-action/${action?.data?.id}`;
        const params = {
            "examination_id": examination_id,
            "type": data?.type,
            "action_user_uid": data?.action_user_uid,
            "day": moment(data?.day).valueOf(),
            "content": data?.content,
            "status": data?.status | 0,
            "next_type": data?.next_type,
            "next_day":  data?.next_day ? moment(data.next_day).valueOf() : undefined,
            "next_action_user_uid": data?.next_action_user_uid,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo hoạt động thành công')
            closeModal()
            props.loadData()
        }
    }

    if (!checkRole(props?.user?.roles, ['receiptsEdit'], props?.user?.role)) {
        return (
            <CardBody className='p-0' style={{ width: 460 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>

        )
    }
    console.log(data, "DDĐEFEFEFE");
    
    return (
        <CardBody className='p-0' style={{ width: 750 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {
                        action?.type === 'add' ? "Tạo hoạt động" :
                            action?.type === 'addAction' ? "Tạo hoạt động" :
                                action?.type === 'editAction' ? "Chỉnh sửa hoạt động" :
                                    action?.type === 'view' ? "Chi tiết hoạt động"
                                        : "Thông báo"
                    }
                </h5>
                <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-2 pt-4">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <Col md={12}>
                        <FormGroup className="label-only">
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Loại hoạt động</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.type ? '---' : "Chọn loại"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, type: val?.value })
                                            }}
                                            value={ActionType?.filter(
                                                (option: any) => data?.type == option.value
                                            )}
                                            options={ActionType}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian thực hiện</Label>
                                        <InputGroup>
                                            <Flatpickr
                                                value={[new Date(data?.day)]}
                                                onChange={(date: any) => {
                                                    setData({
                                                        ...data,
                                                        'day': date[0] ? moment(date[0]) : undefined
                                                    })
                                                }}
                                                options={{
                                                    locale: Vietnamese,
                                                    allowInput: true,
                                                    enableTime: true,
                                                    dateFormat: "d/m/Y H:i",
                                                    altInputClass: "date-range",
                                                    minDate: 'today'
                                                }}
                                                placeholder="dd/mm/yy"
                                            />
                                            {
                                                type != 'view' &&
                                                <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                    <img src={IconCalendar} alt="icon" />
                                                </InputGroupAddon>
                                            }
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Người thực hiện</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.action_user_uid ? '---' : "Chọn người thực hiện"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, action_user_uid: val.value })
                                            }}
                                            value={users?.filter(
                                                (option: any) => data?.action_user_uid == option.value
                                            )}
                                            options={users}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={12} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Kết quả</Label>
                                        <Input type="text" value={type === 'view' && !data?.content ? '---' : data?.content} onChange={(e: any) => handleChangeInput(e)} name="content" placeholder="Nhập kết quả" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {
                                action?.type == "addAction"  &&
                                <div>
                                    <div
                                        className="nutri-checkbox"
                                        onClick={() => setCheckNext(!checkNext)} >
                                        {
                                            checkNext !== true ?
                                                <img src={IconCheckbox} height={20} width={20} alt="icon" /> :
                                                <img
                                                    src={IconCheckboxActive}
                                                    height={20}
                                                    width={20}
                                                    alt="icon"
                                                />
                                        }
                                        &ensp; <span style={{ fontWeight: "bold" }}>Hoạt động tiếp theo</span></div>
                                    {
                                        checkNext == true &&
                                        <Row>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Loại hoạt động</Label>
                                                    <Select
                                                        placeholder={type === 'view' && !data?.next_type ? '---' : "Chọn loại"}
                                                        className="react-select mb-2"
                                                        classNamePrefix="react-select"
                                                        isDisabled={onlyView}
                                                        onChange={(val: any) => {
                                                            setData({ ...data, next_type: val?.value })
                                                        }}
                                                        value={ActionType?.filter(
                                                            (option: any) => !data?.next_examination_action_id ? data?.next_type == option.value : data?.next_examination_action_id?.type == option.value
                                                        )}
                                                        options={ActionType}
                                                        styles={customStyles}
                                                    ></Select>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Thời gian thực hiệnh</Label>
                                                    <InputGroup>
                                                        <Flatpickr
                                                            value={[new Date(!data?.next_examination_action_id ? data?.next_day : data?.next_examination_action_id?.day)]}
                                                            onChange={(date: any) => {
                                                                setData({
                                                                    ...data,
                                                                    'next_day': date[0] ? moment(date[0]) : undefined
                                                                })
                                                            }}
                                                            options={{
                                                                locale: Vietnamese,
                                                                allowInput: true,
                                                                enableTime: true,
                                                                dateFormat: "d/m/Y H:i",
                                                                altInputClass: "date-range",
                                                                minDate: 'today'
                                                            }}
                                                            placeholder="dd/mm/yy"
                                                        />
                                                        {
                                                            type != 'view' &&
                                                            <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                                <img src={IconCalendar} alt="icon" />
                                                            </InputGroupAddon>
                                                        }
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Người thực hiện</Label>
                                                    <Select
                                                        placeholder={type === 'view' && !data?.next_action_user_uid ? '---' : "Chọn người thực hiện"}
                                                        className="react-select mb-2"
                                                        classNamePrefix="react-select"
                                                        isDisabled={onlyView}
                                                        onChange={(val: any) => {
                                                            setData({ ...data, next_action_user_uid: val.value })
                                                        }}
                                                        value={users?.filter(
                                                            (option: any) => !data?.next_examination_action_id ? data?.next_action_user_uid == option.value : data?.next_examination_action_id?.action_user_uid?.id == option.value
                                                        )}
                                                        options={users}
                                                        styles={customStyles}
                                                    ></Select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            }
                            {
                                action?.type == "editAction" && data?.next_examination_action_id &&
                                <div>
                                    <div
                                        className="nutri-checkbox"
                                        onClick={() => setCheckNext(!checkNext)} >
                                        {
                                            checkNext !== true ?
                                                <img src={IconCheckbox} height={20} width={20} alt="icon" /> :
                                                <img
                                                    src={IconCheckboxActive}
                                                    height={20}
                                                    width={20}
                                                    alt="icon"
                                                />
                                        }
                                        &ensp; <span style={{ fontWeight: "bold" }}>Hoạt động tiếp theo</span></div>
                                    {
                                        checkNext == true &&
                                        <Row>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Loại hoạt động</Label>
                                                    <Select
                                                        placeholder={type === 'view' && !data?.next_type ? '---' : "Chọn loại"}
                                                        className="react-select mb-2"
                                                        classNamePrefix="react-select"
                                                        isDisabled={onlyView}
                                                        onChange={(val: any) => {
                                                            setData({ ...data, next_type: val?.value })
                                                        }}
                                                        value={ActionType?.filter(
                                                            (option: any) => !data?.next_examination_action_id ? data?.next_type == option.value : data?.next_examination_action_id?.type == option.value
                                                        )}
                                                        options={ActionType}
                                                        styles={customStyles}
                                                    ></Select>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Thời gian thực hiệnn</Label>
                                                    <InputGroup>
                                                        <Flatpickr
                                                            value={[new Date(!data?.next_examination_action_id ? data?.next_day : data?.next_examination_action_id?.day)]}
                                                            onChange={(date: any) => {
                                                                setData({
                                                                    ...data,
                                                                    'next_day': date[0] ? moment(date[0]) : undefined
                                                                })
                                                            }}
                                                            options={{
                                                                locale: Vietnamese,
                                                                allowInput: true,
                                                                enableTime: true,
                                                                dateFormat: "d/m/Y H:i",
                                                                altInputClass: "date-range",
                                                                minDate: 'today'
                                                            }}
                                                            placeholder="dd/mm/yy"
                                                        />
                                                        {
                                                            type != 'view' &&
                                                            <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                                <img src={IconCalendar} alt="icon" />
                                                            </InputGroupAddon>
                                                        }
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4} xs={12}>
                                                <FormGroup className='nutri-form'>
                                                    <Label>Người thực hiện</Label>
                                                    <Select
                                                        placeholder={type === 'view' && !data?.next_action_user_uid ? '---' : "Chọn người thực hiện"}
                                                        className="react-select mb-2"
                                                        classNamePrefix="react-select"
                                                        isDisabled={onlyView}
                                                        onChange={(val: any) => {
                                                            setData({ ...data, next_action_user_uid: val.value })
                                                        }}
                                                        value={users?.filter(
                                                            (option: any) => !data?.next_examination_action_id ? data?.next_action_user_uid == option.value : data?.next_examination_action_id?.action_user_uid?.id == option.value
                                                        )}
                                                        options={users}
                                                        styles={customStyles}
                                                    ></Select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    } 
                                    <span>Mã hoạt động</span> <br></br>
                                    <span>{data?.next_examination_action_id?.code} &ensp; <a style={{color : "blue"}} href="">Xem chi tiết</a></span>
                                </div>
                            }
                        </FormGroup>
                    </Col>
                </PageContent>
            </div>
            {action?.type !== 'view' &&
                <div className="modal-footer">
                    {action?.type === 'addAction' &&
                        <>
                            <Button onClick={() => { handleSubmit(-1) }} className="ml-2 danger-bland" color="success" type="button" >Thất bại</Button>
                            <Button onClick={() => { handleSubmit(1) }} className="ml-2 success-bland" color="success" type="button" >Thành công</Button>
                            <Button onClick={() => { handleSubmit(0) }} className="ml-2" color="success" type="button" >Lưu mới</Button>
                        </>
                    }
                    {action?.type === 'editAction' &&
                        <>
                            <Button onClick={() => { closeModal() }} className="ml-2 success-bland" color="success" type="button" >Hủy bỏ</Button>
                            <Button onClick={() => { handleEdit() }} className="ml-2" color="success" type="button" >Cập nhật</Button>
                        </>
                    }
                </div>}
            {loading && <Loader />}
        </CardBody>

    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(ActionAdd)